import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import schema from 'components/Person/List/schema';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import { PersonsQuery } from 'components/Person/Form/graphql';
import NavigationProvider from 'components/Navigation/Provider';
import usePermissions from 'store/authentication/usePermissions';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';
import { RoutePrivateProps } from 'components/Route/Private/types';

const PersonForm = React.lazy(() => import('components/Person/Form/Form'));

function ScreensPersonForm(params: Readonly<RoutePrivateProps>) {
  const permissions = usePermissions('persons');
  const id = params.id ? Number(params.id) : null;

  return (
    <BaseLayout className="background-blue">
      <DocumentTitle>
        {params.id ? 'Edit Person' : 'Create Person'}
      </DocumentTitle>
      <NavigationProvider
        id={id}
        buildUrl={(nid: string) => `/people/${nid}/edit`}
        schema={schema}
        query={PersonsQuery}
      >
        <Suspense fallback={<UILoader />}>
          <PersonForm id={id} key={id} personsPermissions={permissions} />
        </Suspense>
      </NavigationProvider>
    </BaseLayout>
  );
}

export default ScreensPersonForm;
